/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PrototypeFirmwareDeleteModel,
  PrototypeFirmwareOnAzure,
  PrototypeFirmwareUpdateModel,
  PrototypeFirmwareUserModel,
  PrototypeInstallLogModel,
  PrototyperToggleModel,
  PrototyperUserInfo,
} from '../models/index';
import {
    PrototypeFirmwareDeleteModelFromJSON,
    PrototypeFirmwareDeleteModelToJSON,
    PrototypeFirmwareOnAzureFromJSON,
    PrototypeFirmwareOnAzureToJSON,
    PrototypeFirmwareUpdateModelFromJSON,
    PrototypeFirmwareUpdateModelToJSON,
    PrototypeFirmwareUserModelFromJSON,
    PrototypeFirmwareUserModelToJSON,
    PrototypeInstallLogModelFromJSON,
    PrototypeInstallLogModelToJSON,
    PrototyperToggleModelFromJSON,
    PrototyperToggleModelToJSON,
    PrototyperUserInfoFromJSON,
    PrototyperUserInfoToJSON,
} from '../models/index';

export interface ApiPrototypeFirmwareAddPostRequest {
    file?: Blob;
    name?: string;
    version?: string;
    description?: string;
}

export interface ApiPrototypeFirmwareAssignUserPutRequest {
    prototypeFirmwareUserModel?: PrototypeFirmwareUserModel;
}

export interface ApiPrototypeFirmwareDeleteDeleteRequest {
    prototypeFirmwareDeleteModel?: PrototypeFirmwareDeleteModel;
}

export interface ApiPrototypeFirmwareDisablePrototyperPutRequest {
    prototyperToggleModel?: PrototyperToggleModel;
}

export interface ApiPrototypeFirmwareDownloadGetRequest {
    id?: string;
}

export interface ApiPrototypeFirmwareEnablePrototyperPutRequest {
    prototyperToggleModel?: PrototyperToggleModel;
}

export interface ApiPrototypeFirmwareLogInstallPostRequest {
    prototypeInstallLogModel?: PrototypeInstallLogModel;
}

export interface ApiPrototypeFirmwareRemoveUserPutRequest {
    prototypeFirmwareUserModel?: PrototypeFirmwareUserModel;
}

export interface ApiPrototypeFirmwareUpdatePutRequest {
    prototypeFirmwareUpdateModel?: PrototypeFirmwareUpdateModel;
}

/**
 * 
 */
export class PrototypeFirmwareApi extends runtime.BaseAPI {

    /**
     */
    async apiPrototypeFirmwareAddPostRaw(requestParameters: ApiPrototypeFirmwareAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrototypeFirmwareOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name'] as any);
        }

        if (requestParameters['version'] != null) {
            formParams.append('version', requestParameters['version'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }


        let urlPath = `/api/PrototypeFirmware/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrototypeFirmwareOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiPrototypeFirmwareAddPost(requestParameters: ApiPrototypeFirmwareAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrototypeFirmwareOnAzure> {
        const response = await this.apiPrototypeFirmwareAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPrototypeFirmwareAssignUserPutRaw(requestParameters: ApiPrototypeFirmwareAssignUserPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/AssignUser`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrototypeFirmwareUserModelToJSON(requestParameters['prototypeFirmwareUserModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPrototypeFirmwareAssignUserPut(requestParameters: ApiPrototypeFirmwareAssignUserPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPrototypeFirmwareAssignUserPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPrototypeFirmwareDeleteDeleteRaw(requestParameters: ApiPrototypeFirmwareDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/Delete`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: PrototypeFirmwareDeleteModelToJSON(requestParameters['prototypeFirmwareDeleteModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPrototypeFirmwareDeleteDelete(requestParameters: ApiPrototypeFirmwareDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPrototypeFirmwareDeleteDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPrototypeFirmwareDisablePrototyperPutRaw(requestParameters: ApiPrototypeFirmwareDisablePrototyperPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/DisablePrototyper`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrototyperToggleModelToJSON(requestParameters['prototyperToggleModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPrototypeFirmwareDisablePrototyperPut(requestParameters: ApiPrototypeFirmwareDisablePrototyperPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPrototypeFirmwareDisablePrototyperPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPrototypeFirmwareDownloadGetRaw(requestParameters: ApiPrototypeFirmwareDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/Download`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async apiPrototypeFirmwareDownloadGet(requestParameters: ApiPrototypeFirmwareDownloadGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.apiPrototypeFirmwareDownloadGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPrototypeFirmwareEnablePrototyperPutRaw(requestParameters: ApiPrototypeFirmwareEnablePrototyperPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/EnablePrototyper`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrototyperToggleModelToJSON(requestParameters['prototyperToggleModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPrototypeFirmwareEnablePrototyperPut(requestParameters: ApiPrototypeFirmwareEnablePrototyperPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPrototypeFirmwareEnablePrototyperPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPrototypeFirmwareGetAllGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrototypeFirmwareOnAzure>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/GetAll`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrototypeFirmwareOnAzureFromJSON));
    }

    /**
     */
    async apiPrototypeFirmwareGetAllGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrototypeFirmwareOnAzure>> {
        const response = await this.apiPrototypeFirmwareGetAllGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPrototypeFirmwareGetAllPrototypersGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrototyperUserInfo>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/GetAllPrototypers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrototyperUserInfoFromJSON));
    }

    /**
     */
    async apiPrototypeFirmwareGetAllPrototypersGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrototyperUserInfo>> {
        const response = await this.apiPrototypeFirmwareGetAllPrototypersGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPrototypeFirmwareGetMyFirmwaresGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrototypeFirmwareOnAzure>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/GetMyFirmwares`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrototypeFirmwareOnAzureFromJSON));
    }

    /**
     */
    async apiPrototypeFirmwareGetMyFirmwaresGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrototypeFirmwareOnAzure>> {
        const response = await this.apiPrototypeFirmwareGetMyFirmwaresGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiPrototypeFirmwareLogInstallPostRaw(requestParameters: ApiPrototypeFirmwareLogInstallPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/LogInstall`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PrototypeInstallLogModelToJSON(requestParameters['prototypeInstallLogModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPrototypeFirmwareLogInstallPost(requestParameters: ApiPrototypeFirmwareLogInstallPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPrototypeFirmwareLogInstallPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPrototypeFirmwareRemoveUserPutRaw(requestParameters: ApiPrototypeFirmwareRemoveUserPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/RemoveUser`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrototypeFirmwareUserModelToJSON(requestParameters['prototypeFirmwareUserModel']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiPrototypeFirmwareRemoveUserPut(requestParameters: ApiPrototypeFirmwareRemoveUserPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPrototypeFirmwareRemoveUserPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiPrototypeFirmwareUpdatePutRaw(requestParameters: ApiPrototypeFirmwareUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrototypeFirmwareOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/PrototypeFirmware/Update`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PrototypeFirmwareUpdateModelToJSON(requestParameters['prototypeFirmwareUpdateModel']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrototypeFirmwareOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiPrototypeFirmwareUpdatePut(requestParameters: ApiPrototypeFirmwareUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrototypeFirmwareOnAzure> {
        const response = await this.apiPrototypeFirmwareUpdatePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
